import React, { lazy , useEffect } from 'react';
import LazySection from 'components/lazySection';
import SectionSkeleton from './sectionskeleton';
import { useLocation } from 'react-router-dom';
const PumpedStorageRole = lazy(() => import("components/Pumped Storage/PumpStoragerole"));

const PumpStorageBanner = lazy(() => import("components/Pumped Storage/PumpStorageBanner"));
const PumpStorageImpactScale = lazy(() => import("components/Pumped Storage/PumpStorageImpactScale"));
const PumpStorageKeyStrength = lazy(() => import("components/Pumped Storage/PumpStorageKeyStrength"));



const PumpStorage: React.FC = () => {
   const { pathname } = useLocation();
  //   useEffect(() => {
  //     window.scrollTo({
  //       top: 0,
  //       left: 0,
  //       behavior: "smooth", // or "smooth"
  //     });
  // }, []);
  useEffect(() => {
    requestAnimationFrame(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    });
  }, [pathname]);
  return (
      <>
        <PumpStorageBanner/>
        {/* Lazy load sections when visible */}
        <LazySection fallback={<SectionSkeleton height={400} />}>
            <PumpStorageKeyStrength />
        </LazySection>

        <LazySection fallback={<SectionSkeleton height={400} />}>
            <PumpStorageImpactScale />
        </LazySection>
          <LazySection fallback={<SectionSkeleton height={400} />}>
            <PumpedStorageRole />
        </LazySection>
        
      </>
  );
};

export default PumpStorage;
